import { BaseModel } from "@blue-chip/core";
import Contact from "./Contact";
import ConsultingCompany from "./ConsultingCompany";

export default class ConsultingCompanyContact extends BaseModel {
  static get belongsTo() {
    return [ConsultingCompany, Contact];
  }
}
